<template>
  <iframe-wrap :option="wrapSize" @loaded="handleLoad">
    <iframe
      ref="contentIframe"
      allowfullscreen="true"
      allow="camera;microphone;display-capture"
      width="100%"
      frameborder="0"
      @load="handleLoad"
    ></iframe>
  </iframe-wrap>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { namespace } from 'vuex-class';
import { ISandboxConfig } from './types';
import { getSandboxIframeUrl } from './util';
import IframeWrap from '@/components/iframe-wrap';
import { IIframewrap } from '@/components/iframe-wrap/type';

const commonMadel = namespace('common');

@Component({
  components: {
    IframeWrap
  }
})
export default class SandboxIframe extends Vue {
  @Prop({ type: Object }) content!: Content & ISandboxConfig & IIframewrap;
  @commonMadel.State('clewordNavVisible') clewordNavVisible: boolean;
  @commonMadel.State('setyleNavHeight') setyleNavHeight: number;

  get url() {
    return getSandboxIframeUrl(this.content);
  }

  get wrapSize() {
    return {
      width: this.content.width,
      height: this.content.height
    };
  }

  mounted() {
    const iframeEl = this.$refs.contentIframe as HTMLIFrameElement;
    iframeEl.src = this.url;
  }

  handleLoad() {
    this.$emit('loaded');
  }
}
</script>

<style scoped>
.wrapper {
  @apply w-full md:ml-12 md:mr-12 rounded-motif overflow-hidden shadow-lg;
  /* background-image: linear-gradient(to right, #6f41ef, #9f7ff7); */
  background-color: #6b6981;
  transition: 0.3s;
}
.enlarge {
  @apply fixed left-0 w-screen h-screen z-50;
  background-color: #6b6981;
  transition: 0.3s;
}
.iframe {
  @apply w-full h-80 overflow-hidden bg-white;
}
.iframe > iframe {
  @apply w-full h-full;
  /* 解决固宽后有黑边问题 */
  transform: scaleX(1.004) translateX(0.1%);
}

.setting {
  @apply flex items-center justify-center;
  flex: 0 0 2rem;
}
</style>
